import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import App from "./App.vue";
import store from "./store";
import i18n from "./lang";
import { post, get } from "./utils/http";
import { VueJsonp } from "vue-jsonp";
import router from "./router/index";
import tool from "./utils/cookie";
import VueCookies from "vue-cookies";
import { registerFilters } from "@/filters";

registerFilters(Vue);

Vue.directive("number-only", {
  inserted(el) {
    el.addEventListener("input", (e) => {
      const input = e.target;
      const value = input.value;
      if (value) {
        input.value = value.replace(/[^\d]/g, "");
      }
    });
    el.addEventListener("paste", (e) => {
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");
      if (pastedText && /[^\d]/.test(pastedText)) {
        e.preventDefault();
      }
    });
  },
});

Vue.config.productionTip = false;
Vue.prototype.tool = tool;
Vue.prototype.formatText = function (formatText) {
  if (!formatText) return "";
  return formatText
    .replace(/  +/g, (match) => "&nbsp;".repeat(match.length))
    .replace(/\n/g, "<br>");
};

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.use(VueJsonp);

Vue.prototype.$isLoggedIn = function () {
  const userInfo = this.$cookies.get("userInfo");
  return !!userInfo && !!userInfo.userid;
};

// 🔥 🔥 🔥 只有这里改了！加了 i18n 关联！！！
Vue.use(ElementUI, {
  size: "normal",
  zIndex: 3000,
  i18n: (key, value) => i18n.t(key, value),
});

Vue.use(VueCookies);

new Vue({
  store,
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#app");
